import useProject from '@hooks/useProject';

function useCurrency() {
    const project = useProject();
    if (project?.serviceCountry === 'JP') {
        return 'JPY';
    }
    return 'KRW';
}

export default useCurrency;
